const SERVICE_DATA = {
    heading: "Our Services",
    description: "A home inspection from All Axis Home Inspections provides a comprehensive analysis of the current condition of a home. Learn more about the systems covered during an inspection below.",
    services_list: [
        {
            label: "Residential Home Inspection",
            text: "The home-buying process can be overwhelming, learn how All-Axis can help inform and protect your largest investment.  Click Here to find out what a home inspection is and what it is Not.",
            icon: "pe-7s-news-paper",
            goto: "#inspection"
        },

        {
            label: "Mold Testing",
            text: "Molds are fungi which occur naturally in the environment.  Mold needs favorable conditions to grow, which are often found inside of homes due to certain building materails combined with the various moisture conditions ",
            icon: "pe-7s-drop" 
        },
        {
            label: "Drone photography",
            text: "State of the art drone photography!  Drones can inspect places a human never could, or perhaps would ever want to.",
            icon: "pe-7s-paper-plane"
        },        
        {
            label: "Pool Inspections",
            text: "All Axis inspectors examine your pool in two parts: visually and mechanically. The visual pool inspection includes looking over pool equipment, electrical supply (including pool lighting) and any safety issues immediately surrounding the pool and pool deck. The mechanical inspection includes the most important equipment as it runs.",
            icon: "pe-7s-help2"
        },
        {
            label: "Radon Testing",
            text: "If you're buying or selling a home, radon can be a significant issue. Not only are high levels of radon unsafe for your family, but they can also drive away potential buyers. Because no area is immune to radon, the Environmental Protection Agency (EPA) recommends that all homes be professionally tested every few years.",
            icon: "pe-7s-science" 
        },
        {
            label: "Pre-occupancy, post occupancy and pre-listing inspections",
            text: "Before you list a property, for sale or rent, having a detailed inspection can assist with the formal documentation of living spaces.  Having an inspection, pre-listing, gives the selling team the data they need to know, before buyers arrive.",
            icon: "pe-7s-video"
        },
        {
            label: "Infrared Thermography",
            text: "Our Inspectors are formally trained in the application of thermal imaging, the proper interpretation of the images, and how that applies to building science.",
            icon: "pe-7s-signal"
        },
        {
            label: "Wood Destroying Insects",
            text: "The team at All-Axis have been properly trained to look for the presence of insects and organisms that attack and destroy structure and finishings of homes.",
            icon: "pe-7s-home"
        },        
        {
            label: "Commercial Inspections",
            text: "Our inspectors conduct thorough walkthroughs, procure necessary experts along with our detailed observations, as well as developing a comprehensive reporting of the components in the commercial space.",
            icon: "pe-7s-id"
        },

        {
            label: "Sewer Scope Inspection",
            text: "An inspection of a home’s sewer line may provide information about the functionality of the drain and waste lines. A borescope camera captures video, provided to the client, which can identify cracks, root intrusion, corrosion, and other defects that would be valuable information when it comes to purchasing a home as well as for preventative maintenance on your existing home, rental property or commercial building. Call today for a further discussion about the process and benefits of a sewer scope inspection.",
            icon: "pe-7s-look"
        },
    ]
};


const OURWAY_DATA = {
    title: 'The All Axis Way!',
    text: 'All-Axis is where integrity, competency, and quality converge.  We understand that the purchasing of a home is usually the biggest financial commitments of your life, possibly wrought with stress and deadlines.  We want to play an essential part of the transaction process, assuring our clients that the asset they are purchasing has been properly and independently examined, in a timely and proficient way.  The staff at All-Axis aim to simplify the results to guarantee that the reporting is understood, and all questions are answered at any time during the process, even after the closing of the home.  We consider it an honor, and a privilege, to represent our clients and we look forward to providing you our services, as you embark upon the future.',
    feature_list: [
        'Prompt inspections, with 24hr reporting available.',
        'COVID Protocols are in place during the inspection.',
        'All Axis Home Inspectors are licensed and insured.',
        'We will go over our findings in person, over the phone, or web conference.',
    ]
};

const PRICING_DATA = {
    title: 'Our Pricing',
    description: 'All homes and structures come with the fixed constants such as roofing, exterior cladding, as well as window, doors and stairways and others. But in addition to those factors, each building will have several variables and components that may affect the amount of time and resources that will influence the pricing of an inspection.  A home with several portable window air conditioners cannot be considered the same as a building with more than one forced air central air conditioner and heating system, as they are immensely different in the methods, protocol, process, and tools necessary for a proper evaluation.',
    footer_note: 'A percentage of all proceeds will be donated to various organizations that promote the awareness, education, and legislation for children diagnosed with Autism, and support for their families.  To learn more, please call and ask … in a world where we can be anything, please be kind.',
    pricing_list: [
        //{
        //     title: 'Single Family',
        //     subtitle: 'Starting Price by Sq Ft',
        //     footer_note:'',            
        //     size_price: [
        //         {
        //             squarefootage: '< 1,000',
        //             starting_price: '$350',                    
        //         },
        //         {
        //             squarefootage: '1,001 - 1,500',
        //             starting_price: '$425',                    
        //         },
        //         {
        //             squarefootage: '1,501 - 2,500',
        //             starting_price: '$495',                    
        //         },                
        //         {
        //             squarefootage: '2,501 - 3,500',
        //             starting_price: '$525',                    
        //         },                
        //         {
        //             squarefootage: '3,501 +',
        //             starting_price: 'Please call',                    
        //         },         
        //     ]
        // },
        // {
        //     title: 'Condo / Townhome',
        //     subtitle: 'Starting Price by Sq Ft',      
        //     footer_note:'',                  
        //     size_price: [
        //         {
        //             squarefootage: '< 1,500',
        //             starting_price: '$375',                    
        //         },
        //         {
        //             squarefootage: '1,501 - 2,500',
        //             starting_price: '$480',                    
        //         },
        //         {
        //             squarefootage: '2,501 +',
        //             starting_price: 'Please Call',                    
        //         },                
        //     ]
        // },
        // {
        //     title: 'Mold',
        //     subtitle: 'Standalone Price / With Home Inspection',        
        //     footer_note:'All mold inspections completed by All-Axis Home Inspections follow IAC2 Guidelines',    
        //     size_price: [
        //         {
        //             squarefootage: 'Single sample',
        //             starting_price: '$175 / $75',                    
        //         },
        //         {
        //             squarefootage: 'Limited Inspection',
        //             starting_price: '$475 / $375',                    
        //         },
        //         {
        //             squarefootage: 'Complete Inspection',
        //             starting_price: '$925 / $700',                    
        //         },       
        //         {
        //             squarefootage: 'Additional Samples',
        //             starting_price: '$100 / $75',                    
        //         },     
        //         {
        //             squarefootage: 'Additional Swab/Lift',
        //             starting_price: '$75 / $50',                    
        //         },                                          
        //     ]
        // },               
        // {
        //     title: 'Infrared Thermography',
        //     subtitle: 'Standalone Price / With Home Inspection',        
        //     footer_note:'A complete inspection of the home, including the interior and exterior, as well as other components, are different inspections.',    
        //     size_price: [
        //         {
        //             squarefootage: 'Basic Components',
        //             starting_price: '$175 / $0',                    
        //         },     
        //         {
        //             squarefootage: 'Whole Building',
        //             starting_price: '$375 / $150',                    
        //         },                                                                    
        //     ]
        // },       
        // {
        //     title: 'Other Services',
        //     subtitle: 'Standalone Price / With Home Inspection',        
        //     footer_note:'',    
        //     size_price: [
        //         {
        //             squarefootage: 'Wood Destroying Insects',
        //             starting_price: '$125 + Tax / $100',                    
        //         },
        //         {
        //             squarefootage: 'Radon Passive Charcoal',
        //             starting_price: '$175 / $125',                    
        //         },                                                           
        //     ]
        // },      
        {
            title: 'Discounts',
            subtitle: 'Apply to Inspection Services only',        
            footer_note:'Not available for Mold and Radon',    
            size_price: [
                {
                    squarefootage: 'Military / First Responder / Teacher',
                    starting_price: '10%',                    
                },
                {
                    squarefootage: 'Platinum Realtor',
                    starting_price: '5-10% w referral ',                    
                },     
                {
                    squarefootage: 'Someone w special needs in home',
                    starting_price: '15%',                    
                },     
                                                                      
            ]
        }                       
    ]
};

const TEAM_DATA = {
        title: 'About Us',
        description: 'I have been in the home business for over nearly thirty years. I’ve benefited from taking part in every aspect of the vast industry, from the “coffee kid” at the jobsite, to crew management at construction builds and renovations. Part of my experience comes with a decade in corporate and retail management in the home improvement industry, where I sharpened my skills to listen to the customers’ needs, address them appropriately, and put their requirements at the top of my list. My military background provides an enhanced attention to detail, pride of a job well done, and ensuring I can help the people in any way possible. My promise to all clients is that I will provide a quality inspection, by competent staff, at a fair price. Front-to-back, side-to-side, and up and down, we will explore every point available of a home, every angle- an All-Axis Inspection!',
        team_list: [
            {
                profile: '/images/joe.jpg',
                name: 'Joe Bisone',
                designation: 'Owner / Inspector',
                email: 'joe@allaxishomeinspections.com'
            },
            {
                profile: '/images/bero.png',
                name: 'Veronica Bisone',
                designation: 'Coordinator',
                email: 'info@allaxishomeinspections.com'
            },
        ]
}

const CERTIFICATION_DATA = {
    title: 'Certifications',
    description: 'Not all home inspectors have the same qualifiations.  At All Axis Home Inspections we are proud to have attained the following certifications:',
    certifications_list: [
        {
            profile: '/images/certifications/certified_inspector.png',
            name: 'Certified Inspector',
            designation: ''
        },
        {
            profile: '/images/certifications/certified_iac2.png',
            name: 'Certified IAC2',
            designation: ''
        },                      
        {
            profile: '/images/certifications/certified_infrared.png',
            name: 'Infrared',
            designation: ''
        },  
        {
            profile: '/images/certifications/certified_mold.png',
            name: 'Mold',
            designation: ''
        },        
        {
            profile: '/images/certifications/certified_PoolAndSpa.png',
            name: 'Pool and Spa',
            designation: ''
        },
        {
            profile: '/images/certifications/certified_radon.png',
            name: 'Radon',
            designation: ''
        },
        {
            profile: '/images/certifications/certified_wdo.png',
            name: 'Wood Destroying Organisms',
            designation: ''
        },              
        {
            profile: '/images/certifications/certified_commercial.png',
            name: 'Commercial',
            designation: ''
        },
        {
            profile: '/images/certifications/certified_SewerScope.png',
            name: 'Sewer Scope',
            designation: ''
        },
        
    ]
}


const TESTIMONIAL_DATA = {
    title :"Testimonials",
    description: "The satisfaction of our clients is paramount. We take pride in exceeding expectations.",
    testimonial_list: [
        {
            profile: 'images/testimonials/female_user.png',
            description: "Joe has been a great independent agent for my rental property.  He is thorough and provides me accurate documentation to ensure that the units are functional, and the security deposits are being utilized according to the leases.",
            name: 'Angela V.',
            text: 'Clifton'
        },
        {
            profile: 'images/testimonials/male_user.png',
            description: "The All-Axis team was extremely flexible, doing the job on a Sunday!  No one does that!  Thanks Joe!",
            name: 'Lamar N.',
            text: 'Jersey City'
        },
        {
            profile: 'images/testimonials/female_user.png',
            description: "When I contacted Joe, he listened to my concerns about the home I was buying.  He performed numerous tests, put my mind at ease and was available well after a normal business day to speak with me and my husband about the results.  5 stars!",
            name: 'Ana A.',
            text: 'North Bergen'
        },
        {
            profile: 'images/testimonials/female_user.png',
            description: "Who would’ve thought the most unexciting part of the process was so worth it?  As first-time home buyers I didn’t think much about the inspection, but Joe was able to provide so much information about the home.  I am extremely thankful there are still good people in this world doing the right thing.",
            name: 'Marisela M.',
            text: 'Rivervale'
        },        
    ]
}

const MOCK_DATA = {
    SERVICE_DATA,
    OURWAY_DATA,
    PRICING_DATA,
    TEAM_DATA,
    TESTIMONIAL_DATA,
    CERTIFICATION_DATA
}

export default MOCK_DATA;